export default __webpack_public_path__ + "static/media/Nitya.87a84758.png";